import { GraphQLWsLink } from "@apollo/client/link/subscriptions";
import { createClient } from "graphql-ws";
import { getToken, isTokenExpired } from "./utils";

const api_url = process.env.NEXT_PUBLIC_API_ENDPOINT!;

// Create a singleton WebSocket link to prevent multiple listeners
let serverSocketLink: GraphQLWsLink | null = null;

const createServerSocketLink = () => {
  // Only create WebSocket link if user is authenticated
  const jwt_token = getToken();
  
  if (!jwt_token || isTokenExpired(jwt_token)) {
    return null;
  }

  // Return existing link if already created
  if (serverSocketLink) {
    return serverSocketLink;
  }

  serverSocketLink = new GraphQLWsLink(
    createClient({
      url: api_url,
      connectionAckWaitTimeout: 5000,
      lazy: true,
      keepAlive: 1000,
      retryWait: async function waitForServerHealthyBeforeRetry(retryAttemps) {
        if (retryAttemps >= 4) {
          console.debug(`socket:DISCONNECTED ${new Date()}`);
        }
        await new Promise((resolve) => setTimeout(resolve, 5000));
      },
      shouldRetry: (errOrCloseEvent) => {
        if (process.env.NODE_ENV === 'development') {
          console.log("errOrCloseEvent", errOrCloseEvent);
        }
        return true;
      },
      connectionParams: async () => ({
        authorization: `Bearer ${jwt_token}`,
      }),
      on: {
        error: (errors) => {
          console.error(`WebSocket ERROR: ${JSON.stringify(errors)}`);
        },
        connected: () => {
          if (process.env.NODE_ENV === 'development') {
            console.log(`socket:CONNECTED ${new Date()}`);
          }
        },
        closed: (reason) => {
          if (process.env.NODE_ENV === 'development') {
            console.log(`socket:CLOSED ${new Date()} -> reason => ${JSON.stringify(reason)}`);
          }
        },
        connecting: () => {
          if (process.env.NODE_ENV === 'development') {
            console.log(`socket:CONNECTING ${new Date()}`);
          }
        },
        ping: async () => {},
        pong: async () => {}
      }
    })
  );

  return serverSocketLink;
};

export const getServerSocketLink = () => createServerSocketLink();

export default getServerSocketLink();